import { render, staticRenderFns } from "./BaseFrontOfficeWalletWrapperOrganization.vue?vue&type=template&id=db8bd98c&scoped=true"
import script from "./BaseFrontOfficeWalletWrapperOrganization.vue?vue&type=script&lang=js"
export * from "./BaseFrontOfficeWalletWrapperOrganization.vue?vue&type=script&lang=js"
import style0 from "./BaseFrontOfficeWalletWrapperOrganization.vue?vue&type=style&index=0&id=db8bd98c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db8bd98c",
  null
  
)

export default component.exports